angular.module('ikeweb.layout', [
    'ikeweb.unit',
    'ikeweb.user',
    'pascalprecht.translate'
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/layout.module.js
// module id = 417
// module chunks = 0